import { Bubble } from '@lt/components';
import type { ILabel } from '@lt/components/components/Label';
import React from 'react';
import classNames from 'classnames';
import { Seagull } from '@lt/components/icons-react/rebrand';

import styles from './hotelCardHeaderLabel.module.css';

const HEADER_LABEL_VARIANTS = {
  1: styles.goldBrown,
  2: styles.bluePurple,
  3: styles.redPink,
  6: styles.limeGreen,
  10: styles.brightBlue,
} as const;

type HotelCardHeaderLabelProps = {
  headerLabel?: ILabel;
  isMobile?: boolean;
};

const HotelCardHeaderLabel: React.FC<HotelCardHeaderLabelProps> = ({
  headerLabel,
  isMobile,
}) => {
  if (!headerLabel) return null;

  const {
    id,
    icon_path: iconPath,
    title,
    description,
    style = 1,
  } = headerLabel;

  return (
    <Bubble
      className={classNames(styles.styledBubble, {
        [styles.styledBubbleMobile]: isMobile,
      })}
      text={description}
    >
      <div
        key={id}
        className={classNames(
          styles.styledLabel,
          HEADER_LABEL_VARIANTS[style],
          { [styles.whiteText]: style === 10 },
        )}
      >
        {/** TODO: Подумать как избавиться */}
        {iconPath ? (
          <div
            className={styles.styledIcon}
            style={{ backgroundImage: `url(${iconPath})` }}
          />
        ) : (
          <div className={styles.styledBird}>
            <Seagull />
          </div>
        )}
        <span>{title}</span>
      </div>
    </Bubble>
  );
};

export default HotelCardHeaderLabel;
